import { render, staticRenderFns } from "./ProjectSectorsAndApplications.vue?vue&type=template&id=569bfb21&"
import script from "./ProjectSectorsAndApplications.vue?vue&type=script&lang=js&"
export * from "./ProjectSectorsAndApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VProgressCircular,VSelect})
